export default "__VITE_ASSET__5b17e199__"